<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-md-8">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEditMode ? 'Edição de ' : 'Cadastro de '}}Contas a Receber</h1>
                        <p class="welcome-message">
                            <button mat-icon-button [routerLink]="rotaVoltar">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados da Conta a Receber
                        </p>
                    </div>
                </div>
            </div>

            @if (isEditMode && isAgrupado) {
            <div class="col-md-4 d-flex justify-content-end align-items-start">
                <button mat-button type="button" (click)="desagrupar()" [disabled]="desagrupando"
                    matTooltip="Desfaz o agrupamento: reabre as parcelas originais (em aberto) e remove este lançamento consolidado. Cobranças (PIX/boleto) ativas deste lançamento são canceladas."
                    matTooltipPosition="below">
                    @if (desagrupando) {
                    <mat-spinner diameter="16"></mat-spinner>
                    } @else {
                    <mat-icon class="material-symbols-outlined">call_split</mat-icon>
                    Desagrupar lançamento
                    }
                </button>
            </div>
            }
        </div>

        @if (isEditMode && idVenda) {
        <app-alert-card type="info" icon="shopping_cart" class="mb-3 d-block">
            Gerado pelo <strong>pedido de venda nº {{ numeroDocumentoVenda }}</strong>. Valor, vencimento, forma de
            recebimento, conta e cliente só mudam pelo pedido; baixa, estorno, cobrança, tags e categoria continuam
            pela lista de contas a receber.
        </app-alert-card>
        }

        @if (isEditMode && idNFeSaida) {
        <app-alert-card type="info" icon="description" class="mb-3 d-block">
            Gerado pela <strong>NF-e de saída nº {{ numeroDocumentoVenda }}</strong>. Para alterar ou excluir, use
            "Excluir financeiro" na nota; baixa, estorno, cobrança, tags e categoria continuam pela lista de contas a
            receber.
        </app-alert-card>
        }

        @if (isLoading || isLoadingLookups) {
        <div class="row">
            <div class="col-12 mb-4">
                <app-loading-box [height]="'30'" [width]="'250'" [margin]="'0 0 20px 0'"></app-loading-box>

                <div class="row">
                    <div class="col-12 mb-3">
                        <app-loading-box [height]="'150'"></app-loading-box>
                    </div>
                    <div class="col-6 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                    <div class="col-6 mb-3">
                        <app-loading-box [height]="'100'"></app-loading-box>
                    </div>
                </div>
            </div>
        </div>
        } @else {

        <form [formGroup]="form" (ngSubmit)="salvar()">

            <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

            <div class="section-container" id="dados-gerais">
                <div class="section-title">
                    <mat-icon>assignment</mat-icon>
                    <span>Dados Gerais</span>
                </div>
                <app-contas-receber-dados-gerais [parentForm]="form"
                    [listaCategoriasFinanceiras]="lookups?.categoriasFinanceiras ?? []" [currencyMask]="currencyMask"
                    [camposObrigatorios]="camposObrigatorios">
                </app-contas-receber-dados-gerais>
            </div>

            <div class="section-container" id="rateio">
                <div class="section-title">
                    <mat-icon>pie_chart</mat-icon>
                    <span>Centro de Custo</span>
                </div>
                <app-contas-receber-centro-custo [parentForm]="form" [valorTotalDoc]="valorTotalDocumento"
                    [listaCentrosCusto]="lookups?.centrosCusto ?? []"
                    [listaGridConfiguracoes]="lookups?.rateiosCentroCusto ?? []" [currencyMask]="currencyMask"
                    [percentageMask]="percentageMask" [isCentroCustoObrigatorio]="isObrigatorio('id_centro_custo')">
                </app-contas-receber-centro-custo>
            </div>

            <div class="section-container" id="parcelamento">
                <div class="section-title">
                    <mat-icon>calendar_today</mat-icon>
                    <span>Parcelamento / Repetição</span>
                </div>
                <app-contas-receber-parcelamento [parentForm]="form" [isEditMode]="isEditMode"
                    [qtdParcelas]="qtdParcelas" [idContasReceber]="idContasReceber"
                    [hasParcelasEmAberto]="hasParcelasEmAberto"
                    [listaTiposParcelamento]="lookups?.tiposParcelamento ?? []"
                    [listaFrequencia]="lookups?.frequenciasRecorrencia ?? []"
                    [listaContaFinanceira]="lookups?.contasFinanceiras ?? []"
                    [listaFormaRecebimento]="lookups?.formasRecebimento ?? []" [currencyMask]="currencyMask"
                    [integerMask]="integerMask"
                    [camposObrigatorios]="camposObrigatorios" [isOrigemVenda]="!!idVenda" [isOrigemNFeSaida]="!!idNFeSaida"
                    (renegociarClick)="abrirRenegociacao()">
                </app-contas-receber-parcelamento>
            </div>

            @if (isEditMode && qtdParcelas === 1) {
            <div class="section-container" id="previsao">
                <div class="section-title">
                    <mat-icon>monetization_on</mat-icon>
                    <span>Previsão de Recebimento</span>
                </div>
                <app-contas-receber-previsao [parentForm]="form"
                    [currencyMask]="currencyMask"></app-contas-receber-previsao>
            </div>
            }

            <div class="section-container" id="complementos">
                <div class="section-title">
                    <mat-icon>description</mat-icon>
                    <span>Arquivos e Complementos</span>
                </div>
                <app-contas-receber-complementares [parentForm]="form" [camposObrigatorios]="camposObrigatorios"
                    [tagsControl]="tagsControl" [listaTag]="lookups?.tags ?? []"
                    [mostrarTags]="mostrarTags" [isSomenteLeitura]="isOrigemDocumento"></app-contas-receber-complementares>
            </div>

        </form>
        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="desagrupando || isOrigemDocumento" (cancelar)="cancelar()" (salvar)="salvar()"></app-footer-action>